import { ActionIcon } from '@mantine/core';
import { IconLock, IconLockOpen } from '@tabler/icons-react';

type Props = {
  isLocked: boolean;
  onToggle: () => void;
};

export function LockToggle({ isLocked, onToggle }: Props) {
  return (
    <ActionIcon
      variant="subtle"
      color="gray"
      size="sm"
      onClick={onToggle}
      aria-label={isLocked ? 'Unlock editor' : 'Lock editor'}
    >
      {isLocked ? <IconLock size={16} /> : <IconLockOpen size={16} />}
    </ActionIcon>
  );
}
